export const SAME_DAY_CARE_ID = '1034002261';
const phoneNumberPattern = /^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    //basic email regex

export const isValidPhoneNumber = value => {
    return value && value.trim() && phoneNumberPattern.test(value);
};

export const isValidEmail = value => {
    return value && value.trim() && emailPattern.test(value);
}

export const getValue = (field, conditionForDefaultValue, defaultValue, ...objects) => {
    if (conditionForDefaultValue) {
        return defaultValue;
    }
    else {
        for (let i = 0; i < objects.length; i++) {
            const obj = objects[i];
            if (obj && typeof obj[field] !== 'undefined') {
                return obj[field];
            }
        }
    }
    return defaultValue;
};

export const mybswhTooltipMsg = 'This provider allows you to use MyBSWHealth which is a mobile app and web portal where you can: manage appointments, message your doctor, view visit summary, test results, pay bills, and much more!';

export const availabilityList = [
    { value: -1, display: 'No Preference' }, { value: 0, display: 'Any Day' }, { value: 1, display: 'Today' }, { value: 3, display: 'Next 3 Days' }
];

export const genderList = [
    { value: 'Any', display: 'No Preference' }, { value: 'Male', display: 'Male' }, { value: 'Female', display: 'Female' }
];

export const inList = (item, list, fieldName1, fieldName2) => {
    for (let i = 0; i < list.length; i++) {
        if (item[fieldName1] === list[i][fieldName2]) {
            return true;
        }
    }
    return false;
};

// this function converts an error message of a failing zipnosis api call to a custom matching one given in app.config;
// inside this function, the app.config key names of the custom messages are defined as field names of the object "pairs";
// part of strings expected to appear in the original error are defined as values in this object.
export const convertZipnosisErrorMessage = (error) => {
    const thePostalCode = "The postal code";
    const pairs = {
        zipnosisInvalidZipCodeMessage: thePostalCode,
        zipnosisNoEmailMessage: "Email can't be blank|No EMAIL on file for this user",
        zipnosisEmailTakenMessage: "Email has already been taken",
        zipnosisNoGenderMessage: "Gender is not included",
        zipnosisInvalidTokenDependentMessage: "Invalid token - user is a dependent",
        zipnosisActivatedPatientMessage: "Patient already activated",
        zipnosisFailedToAuthenticateMessage: "Failed to authenticate the user",
        zipnosisNoMemberMessage: "Member record not found",
        zipnosisAccountLockedMessage: "Your account is locked",
        zipnosisNoEPID: "No EPID on file for this user",
        zipnosisInvalidPhoneMessage: "Phone is an invalid number"
    };

    const keys = Object.keys(pairs);
    for (let i = 0; i < keys.length; i++) {
        const errorMessageName = keys[i];
        const values = pairs[errorMessageName].split('|');
        for (let j = 0; j < values.length; j++) {
            const errorToSearchFor = values[j];
            const index = error.indexOf(errorToSearchFor);
            if (index > -1) {
                //if (errorToSearchFor === thePostalCode) { // to take care of this kind of error: \"...The postal code 78702 is not valid for the state of SC\"
                //    const errorMessage = error.substr(index, error.indexOf('\"'));
                //    if (errorMessage) {
                //        return { errorMessage, errorMessageName };
                //    }
                //}
                return { errorMessage: window.serverData.data[errorMessageName], errorMessageName };
            }
        }
    }

    const errorMessageName = "zipnosisDefaultMsg";
    return { errorMessage: window.serverData.data[errorMessageName], errorMessageName };
    //return null;
};